import fetchTeamData from './fetchTeamData';
import pushToPage from './pushToPage';
import fetchFundraisingPages from './fetchFundraisingPages';
import fetchMembersList from './fetchMembersList';
import submitTeamData from './submitTeamData';
import updateMembershipPolicy from './updateMembershipPolicy';
import unlinkMember from './unlinkMember';
import deleteTeam from './deleteTeam';
import logInfo from './logInfo';
import fetchAppData from './fetchAppData';
import updateTeamLocks from './updateTeamLocks';

const apiThunk = {
  fetchTeamData,
  fetchFundraisingPages,
  fetchMembersList,
  deleteTeam,
  submitTeamData,
  updateMembershipPolicy,
  unlinkMember,
  logInfo,
  fetchAppData,
  updateTeamLocks,
};

const appThunk = {
  pushToPage,
};

export { apiThunk, appThunk };
